import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { memo } from 'react';

import { Badge, Space, Typography } from '@sravni/react-design-system';

import { CatCard } from '@src/assets';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';

import styles from './FullDealEntryPointBanner.module.scss';
import { FullDealEntryPointBannerTexts } from './FullDealEntryPointBanner.texts';
import { useBadgeTime } from './lib';

interface Props {
  hasOffer: boolean;

  // пока оставил мало ли понадобится
  // eslint-disable-next-line react/no-unused-prop-types
  heading?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  isLanding?: boolean;
  mobileBanner: ReactNode;
}

export const FullDealEntryPointBanner = memo(({ hasOffer, mobileBanner, isLanding, heading }: Props) => {
  const time = useBadgeTime(hasOffer);

  return (
    <Space justify="space-between" className={styles.container}>
      <div>
        {/* todo: сделали дивом по указанию СЕО https://sravni-corp.slack.com/archives/C08LAGUJQRZ/p1755239085670589 */}
        <Typography.Heading level={isLanding ? 1 : 2} className={styles.title} as="div">
          {isLanding ? heading || FullDealEntryPointBannerTexts.title : FullDealEntryPointBannerTexts.title}
        </Typography.Heading>
        <Badge
          variant="primary"
          color="dark"
          text={
            hasOffer
              ? FullDealEntryPointBannerTexts.badgeTitle
              : FullDealEntryPointBannerTexts.badgeTitleWithTime.replace('{time}', time)
          }
        />
      </div>
      <div className={classNames(styles.image, 'desktop:hidden')}>{mobileBanner && mobileBanner}</div>

      {/* <OptimizedPicture
        imgClassName={classNames(styles.image, 'desktop:hidden')}
        img={CatCard}
        width={120}
        height={130}
        loading="eager"
        fetchpriority="high"
        alt="logo"
      /> */}
    </Space>
  );
});

FullDealEntryPointBanner.displayName = 'FullDealEntryPointBanner';
